"use client";

import { BlogPost } from "@/types";
import { Panel } from "@/components/ui/Panel";
import Link from "next/link";

export function BlogPostArticle({ post }: { post: BlogPost }) {
  return (
    <Panel className="w-full xl:w-2/3">
      <div className=" relative overflow-hidden">
        <article className=" relative z-20 flex flex-col gap-6 overflow-hidden">
          <h1 className="page-headline text-softiq-secondary transition-colors duration-300">
            {post.title}
          </h1>

          <div
            className="blog-post text-sm text-foreground"
            dangerouslySetInnerHTML={{
              __html: post.content_html ?? "",
            }}
          />
          <aside className="rounded-2xl bg-hover p-6">
            <h2 className="!mt-0 !border-0 !pb-0 text-xl font-semibold text-softiq-secondary">
              Kompletní software pro správu nemovitostí
            </h2>
            <p className="mt-3 leading-7 text-foreground/80">
              Spravujte portfolio, finance, dokumenty a důležité termíny na
              jednom místě. SOFTIQ vám navíc pomůže hledat nové investiční
              příležitosti.
            </p>
            <Link
              href="/#cenik"
              className="mt-4 inline-flex font-semibold text-softiq-secondary underline decoration-softiq-primary underline-offset-4"
            >
              Vyzkoušet SOFTIQ zdarma
            </Link>
          </aside>
        </article>
      </div>
    </Panel>
  );
}
